import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// Roomier on mobile (bigger padding + tap target) and compact on desktop where the dialog is small.
export const settingsRowClass = 'group flex w-full items-center gap-3 rounded-xl border border-solid border-border/50 bg-secondary/20 p-4 text-left transition-colors hover:border-border hover:bg-secondary/40 sm:p-3';
export const SettingsRowInner = ({ label, description, Icon, isLink = false }) => (<>
		<div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-solid border-accent/20 bg-accent/10 text-accent sm:h-9 sm:w-9">
			<Icon sx={{ fontSize: { xs: 20, sm: 18 } }}/>
		</div>
		<div className="min-w-0 flex-1">
			<p className="text-sm font-medium text-foreground sm:text-xs">{label}</p>
			{description && <p className="truncate text-xs text-muted-foreground sm:text-[10px]">{description}</p>}
		</div>
		{isLink && (<OpenInNewIcon sx={{ fontSize: { xs: 17, sm: 15 } }} className="flex-shrink-0 text-muted-foreground/40 transition-colors group-hover:text-muted-foreground/70"/>)}
	</>);
